(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('CommunicationCampaign', CommunicationCampaign);

    CommunicationCampaign.$inject = ['$resource', 'DateUtils'];

    function CommunicationCampaign($resource, DateUtils) {
        var resourceUrl = 'api/communication-campaign/:id';

        function transformCampaignFromServer(data) {
            if (!data) {
                return data;
            }
            data = angular.fromJson(data);
            if (data) {
                data.desiredSendDate = DateUtils.convertDateTimeFromServer(data.desiredSendDate);
                data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
            }
            return data;
        }

        function transformCampaignToServer(data) {
            var clonedData = Object.assign({}, data);
            clonedData.desiredSendDate = data.desiredSendDate;
            clonedData.createdDate = data.createdDate;
            clonedData.lastModifiedDate = data.lastModifiedDate;
            return angular.toJson(clonedData);
        }

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                transformResponse: function(data) {
                    if (!data) {
                        return [];
                    }
                    data = angular.fromJson(data);
                    angular.forEach(data, function(item) {
                        item.desiredSendDate = DateUtils.convertDateTimeFromServer(item.desiredSendDate);
                        item.createdDate = DateUtils.convertDateTimeFromServer(item.createdDate);
                        item.lastModifiedDate = DateUtils.convertDateTimeFromServer(item.lastModifiedDate);
                    });
                    return data;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: transformCampaignFromServer
            },
            'save': {
                method: 'POST',
                transformRequest: transformCampaignToServer
            },
            'update': {
                method: 'PUT',
                transformRequest: transformCampaignToServer
            },
            'cancel': {
                method: 'POST',
                url: 'api/communication-campaign/:id/cancel'
            },
            'preview': {
                method: 'POST',
                url: 'api/communication-campaign/preview',
                transformRequest: transformCampaignToServer
            },
            'searchContracts': {
                method: 'GET',
                url: 'api/communication-campaign/search-contracts'
            },
            'downloadcsv': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
                url: 'api/communication-campaign/downloadcsv',
                transformResponse: function(data, headers) {
                    var filename = headers('FileName');
                    var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName: filename,
                        contentType: contentType
                    };
                }
            },
            'downloadCampaigncsv': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
                url: 'api/communication-campaign/:id/downloadcsv',
                transformResponse: function(data, headers) {
                    var filename = headers('FileName');
                    var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName: filename,
                        contentType: contentType
                    };
                }
            },
            'getChannel': {
                method: 'GET',
                url: 'api/channel',
                isArray: true
            },
            'chatAssistant': {
                method: 'POST',
                url: 'api/communication-campaign/assistant/chat'
            },
            'getAssistantUsage': {
                method: 'GET',
                url: 'api/communication-campaign/assistant/usage'
            },
            'submitAssistantFeedback': {
                method: 'POST',
                url: 'api/communication-campaign/assistant/feedback'
            }
        });
    }
})();
